module.exports = __webpack_public_path__ + "img/Wooden Hand iPhone 12 Pro.e1d8f5e0.png";